$('.product-slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: true,
  arrows: true,
   responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});

 


$('.collection-list').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
   responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});
  const updateUpsellSwiper = () => {
    const upsell1 = new Swiper(".custom-upsell-swiper-slider", {
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    const upsell2 = new Swiper(".custom-upsell-swiper-slider2", {
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
var main_logo = new Swiper(".main_logo_width_text", {
      slidesPerView: 2.2,
      loop: false,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1700: {
          slidesPerView: 5,
        },
        1400: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 5,
        },
        1024: {
          slidesPerView: 3,
        },
        767: {
          slidesPerView: 2,
        },
      },
    });